import React, { Component } from 'react';

class EditInstitucion extends Component {
    state = {  }
    render() { 
        return (
            <div>Editar Institución</div>
        );
    }
}
 
export default EditInstitucion;


// WEBPACK FOOTER //
// ./src/views/WebMaster/EditInstitucion.jsx